import { formatDate } from '@/libs/utils'
import axios from 'axios'
const state = {}
import config from '@/../config'
const defaultErrorHandler = (error => Promise.reject(error.response))

const mutations = {}

const actions = {

    async GET_PROPOSAL({
        commit
    }, payload) {
        let data
        let response = await axios.get(config.apiUrl + config.versoes[0] + `/produto/${payload.id_produto
            }/proposta/${payload.id_proposta
            }`)
        data = response.data
        data.tomador = {
            cnpj_cpf: data.tomador.cnpj_cpf,
            nome: data.tomador.nome,
            endereco: data.tomador.endereco

        }
        data.segurado = {
            cnpj_cpf: data.segurado.cnpj_cpf,
            nome: data.segurado.nome,
            endereco: data.segurado.endereco

        }
        data.modalidades = {
            grupo: data.grupo_sublimite,
            adicionais: []
        }

        data.coberturas && data.coberturas.forEach(item => {
            if (item.tipo == 'basica') {
                data.modalidades.principal = item.nome
            }
            if (item.tipo == 'corretiva') {
                data.modalidades.complementar = item.nome
            }

            item.fim_vigencia_formatted = formatDate(item.fim_vigencia)
            item.inicio_vigencia_formatted = formatDate(item.inicio_vigencia)
        })

        return data
    },

    async SAVE_PROPOSAL({
        commit
    }, payload) {
        let response = await axios.post(config.apiUrl + config.versoes[0] + '/proposal', payload)
        return response.data
    },

    async QUIT_PROPOSAL({
        commit
    }, payload) {
        
        let response = await axios.patch(config.apiUrl + config.versoes[0] + `/produto/${payload.id_produto
            }/proposta/${payload.id_proposta
            }`, payload)
        return response.data
    },

    async GET_PROPOSAL_PRODUCTS({
        commit
    }, payload) {

        let response = await axios.get(config.apiUrl + config.versoes[0] + `/modalidade?id_tomador=${payload.takerId
            }&id_segurado=${payload.insuredId
            }`)

        return response.data
    },

    async POST_PROPOSTA({
        commit
    }, payload) {
        
        let response = await axios.post(config.apiUrl + config.versoes[0] + `/produto/${payload.id_produto
            }/proposta/`, payload)
        return response.data
    },

    async PUT_PROPOSTA({
        commit
    }, payload) {
        let response = await axios.put(config.apiUrl + config.versoes[0] + `/produto/${payload.id_produto
            }/proposta/${payload.id_proposta
            }`, payload)
        return response.data
    },

    async PATCH_PROPOSTA({
        commit
    }, payload) {

        let response = await axios.patch(config.apiUrl + config.versoes[0] + `/produto/${payload.id_produto
            }/proposta/${payload.id_proposta}`, payload)

        return response.data
    },

    async GET_PRODUCTS_COMBO({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + `/produtos`);
        return response.data;
    },

    async GET_PRODUCTS({
        commit
    }, payload) {
        
        let response = await axios.get(config.apiUrl + config.versoes[0] + `/modalidade/detalhe/?id_tomador=${payload.takerId
            }&id_segurado=${payload.insuredId
            }&coberturas=['${payload.products.join("','")
            }']`)
        return response.data
    },

    async LIST_USERS_COMPANY({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + '/companies/email/' + payload.hash)
        return response.data
    },

    async POST_QUESTIONAMENTO({
        commit
    }, payload) {
        let propostaId = payload.propostaId
        delete payload.propostaId

        let produtoId = payload.produtoId
        delete payload.produtoId

        let response = await axios.post(config.apiUrl + config.versoes[0] + `/produto/${produtoId}/proposta/${propostaId}/questionamento/`, payload)
        return response.data
    },

    async POST_REVISAO_CREDITO({
        commit
    }, payload) {
        let response = await axios.post(config.apiUrl + config.versoes[0] + `/produto/${payload.produtoId}/proposta/${payload.propostaId}/revisao-credito/`, payload.model);

        return response.data
    },

    async POST_REVISAO_SUBSCRICAO({
        commit
    }, payload) {
        let propostaId = payload.propostaId;
        let produtoId = payload.produtoId;

        let response = await axios.post(config.apiUrl + config.versoes[0] + `/produto/${produtoId}/proposta/${propostaId}/revisao-subscricao/`, payload.model);

        return response.data
    },

    async GET_MINUTA({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + `/produto/${payload.id_produto
            }/proposta/${payload.id_proposta
            }/minuta`, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        })

        if (response.status != 200) {
            throw response.data
            return
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `minuta_${payload.id_proposta
            }_${payload.id_produto
            }.pdf`);
        document.body.appendChild(link);
        link.click();
        return


    },

    async GET_DOCUMENTO_APOLICE({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + `/produto/${payload.id_produto
            }/proposta/${payload.id_proposta
            }/minuta`, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        })

        if (response.status != 200) {
            throw response.data
            return
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `apolice_${payload.id_apolice
            }.pdf`);
        document.body.appendChild(link);
        link.click();
        return


    },

    async GET_BOLETO({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + `/produto/${payload.id_produto
            }/proposta/${payload.id_proposta
            }/boletos`, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/zip'
            }
        })

        if (response.status != 200) {
            throw response.data
            return
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `boleto_${payload.id_apolice
            }.zip`);
        document.body.appendChild(link);
        link.click();
        return


    },

    async GET_REASONS({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + `/proposta/motivo-desistencia`)
        return response.data
    },

    async GET_PARAMETERS({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + `/parametros/proposta`)
        return response.data
    },

    async GET_PREMIO_MIN({
        commit
    }, payload){
        let response = await axios.get(config.apiUrl + config.versoes[0] + `/premioMinimo?importancia_segurada=${payload.importancia_segurada}&dias_vigencia=${payload.vigencia}&documento_tomador=${payload.documento}&id_produto=${payload.id_prod}`);
        return response.data
    }

}

export default { state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/proposal.js